module.exports = __webpack_public_path__ + "static/4-e90a7fe037dd0dd403054f822c35e14a.jpg";